import { render, staticRenderFns } from "./easyTag.vue?vue&type=template&id=cbef0f88&scoped=true&"
import script from "./easyTag.vue?vue&type=script&lang=js&"
export * from "./easyTag.vue?vue&type=script&lang=js&"
import style0 from "./easyTag.vue?vue&type=style&index=0&id=cbef0f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef0f88",
  null
  
)

export default component.exports